var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect2, _rect3, _rect4, _circle, _circle2, _rect5, _circle3, _rect6, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.695312,
    width: 68,
    height: 68,
    rx: 16,
    fill: "#F7F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4111 17.9531L14.5312 38.4609",
    stroke: "#CFD6D9",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8096 17.9531L38.9297 38.4609",
    stroke: "#CFD6D9",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1904 17.9531L29.0703 38.4609",
    stroke: "#CFD6D9",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.585 17.9531L53.4648 38.4609",
    stroke: "#CFD6D9",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9919 28.7422H23.9768C24.3383 28.7422 24.5803 29.1139 24.4341 29.4444L23.0018 32.6824H24.2472C24.6805 32.6824 24.9087 33.196 24.6182 33.5176L21.2086 37.2924C20.866 37.6716 20.2422 37.3533 20.3484 36.8533L20.7667 34.8836C20.8328 34.5726 20.5956 34.2797 20.2776 34.2797H19.3676C19.0213 34.2797 18.7799 33.9362 18.8972 33.6103L18.9939 33.3418C18.9988 33.3159 19.0058 33.29 19.0151 33.2642L20.5213 29.0731C20.5927 28.8746 20.7809 28.7422 20.9919 28.7422Z",
    fill: "#37435A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3903 28.7422H48.3753C48.7367 28.7422 48.9788 29.1139 48.8325 29.4444L47.4003 32.6824H48.6456C49.0789 32.6824 49.3071 33.196 49.0166 33.5176L45.607 37.2924C45.2644 37.6716 44.6407 37.3533 44.7469 36.8533L45.1652 34.8836C45.2312 34.5726 44.994 34.2797 44.6761 34.2797H43.7661C43.4197 34.2797 43.1783 33.9362 43.2956 33.6103L43.3923 33.3418C43.3972 33.3159 43.4042 33.29 43.4135 33.2642L44.9198 29.0731C44.9911 28.8746 45.1794 28.7422 45.3903 28.7422Z",
    fill: "#37435A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0156 38.4609H30.5907V38.4609C30.5907 39.1216 30.0551 39.6572 29.3944 39.6572H14.2119C13.5512 39.6572 13.0156 39.1216 13.0156 38.4609V38.4609Z",
    fill: "#37435A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4141 38.4609H54.9891V38.4609C54.9891 39.1216 54.4535 39.6572 53.7928 39.6572H38.6104C37.9497 39.6572 37.4141 39.1216 37.4141 38.4609V38.4609Z",
    fill: "#37435A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8477 50.4375C19.8477 49.3329 20.7431 48.4375 21.8477 48.4375H46.1569C47.2615 48.4375 48.1569 49.3329 48.1569 50.4375V51.3551H19.8477V50.4375Z",
    fill: "#788AAB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8711 53.3594C17.8711 52.2548 18.7665 51.3594 19.8711 51.3594H48.1362C49.2407 51.3594 50.1362 52.2548 50.1362 53.3594V53.5905H17.8711V53.3594Z",
    fill: "#37435A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0938 48.4363C32.0938 48.0487 32.408 47.7344 32.7957 47.7344H35.2072C35.5949 47.7344 35.9092 48.0487 35.9092 48.4363V48.4363H32.0938V48.4363Z",
    fill: "#37435A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7891,
    y: 17.7422,
    width: 2.43794,
    height: 29.9948,
    fill: "#37435A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.207,
    y: 18.5469,
    width: 1.6,
    height: 27.5889,
    rx: 0.8,
    transform: "rotate(-90 20.207 18.5469)",
    fill: "#37435A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7891,
    y: 17.7422,
    width: 2.43794,
    height: 29.9948,
    fill: "#37435A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.0054,
    cy: 17.7124,
    r: 1.90773,
    fill: "#FFE066"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.0057,
    cy: 17.7127,
    r: 0.650239,
    fill: "#37435A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2031,
    y: 16.1016,
    width: 3.19688,
    height: 3.29231,
    rx: 1,
    fill: "#ADBAD1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.8035,
    cy: 17.741,
    r: 0.811281,
    fill: "#37435A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5977,
    y: 16.1016,
    width: 3.19688,
    height: 3.29231,
    rx: 1,
    fill: "#ADBAD1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.1941,
    cy: 17.741,
    r: 0.811281,
    fill: "#37435A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoad);
export default __webpack_public_path__ + "static/media/load.c25d41c0e631dda4063faa46ca80f027.svg";
export { ForwardRef as ReactComponent };